import script from "./CollabApplyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CollabApplyModal.vue?vue&type=script&setup=true&lang=js"

import "./CollabApplyModal.vue?vue&type=style&index=0&id=1a32629c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a32629c"]])

export default __exports__